import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, setBlockTracking as _setBlockTracking, createTextVNode as _createTextVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "outer" }
const _hoisted_2 = {
  class: "inner hide-scrollbar",
  ref: "inner"
}
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "overlay top-left fill-block" }
const _hoisted_5 = {
  key: 0,
  class: "left-btn dir-btn"
}
const _hoisted_6 = {
  key: 1,
  class: "right-btn dir-btn"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_XImg = _resolveComponent("XImg")!
  const _component_LeftMoveIcon = _resolveComponent("LeftMoveIcon")!
  const _component_NcActionButton = _resolveComponent("NcActionButton")!
  const _component_NcActions = _resolveComponent("NcActions")!
  const _component_RightMoveIcon = _resolveComponent("RightMoveIcon")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.years, (year) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "group",
          key: year.text,
          onClick: ($event: any) => (_ctx.click(year))
        }, [
          _createVNode(_component_XImg, {
            class: "fill-block",
            src: year.url
          }, null, 8, ["src"]),
          _createElementVNode("div", _hoisted_4, _toDisplayString(year.text), 1)
        ], 8, _hoisted_3))
      }), 128))
    ], 512),
    (_ctx.hasLeft)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createVNode(_component_NcActions, null, {
            default: _withCtx(() => [
              _createVNode(_component_NcActionButton, {
                "aria-label": _ctx.t('memories', 'Move left'),
                onClick: _ctx.moveLeft
              }, {
                icon: _withCtx(() => [
                  _cache[0] || (
                    _setBlockTracking(-1, true),
                    (_cache[0] = _createVNode(_component_LeftMoveIcon, { size: 28 })).cacheIndex = 0,
                    _setBlockTracking(1),
                    _cache[0]
                  )
                ]),
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t('memories', 'Move left')) + " ", 1)
                ]),
                _: 1
              }, 8, ["aria-label", "onClick"])
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    (_ctx.hasRight)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createVNode(_component_NcActions, null, {
            default: _withCtx(() => [
              _createVNode(_component_NcActionButton, {
                "aria-label": _ctx.t('memories', 'Move right'),
                onClick: _ctx.moveRight
              }, {
                icon: _withCtx(() => [
                  _cache[1] || (
                    _setBlockTracking(-1, true),
                    (_cache[1] = _createVNode(_component_RightMoveIcon, { size: 28 })).cacheIndex = 1,
                    _setBlockTracking(1),
                    _cache[1]
                  )
                ]),
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t('memories', 'Move right')) + " ", 1)
                ]),
                _: 1
              }, 8, ["aria-label", "onClick"])
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true)
  ], 512)), [
    [_vShow, _ctx.years.length > 0]
  ])
}